<template>
	<div class="flex flex_items_center">
		<EnumSelect
			class="flex_1"
			v-model="selectedType"
			:label="$t('common.documentType')"
			:enum-def="enumDef.fileMappingType"
			:filtered-values="fileTypeCandidates"
			:required="required"
			:disabled="!allowChangeType"
		/>
		<CommonFileUpload
			class="flex_2 margin_l"
			:value="uploadedFile"
			@input="onFileChanged"
			placeholderKey="common.upload"
			:uploadFunction="uploadDocumentWithSelectedType"
			:required="required"
			:error="error"
		/>
		<md-button v-if="!required" class="md-simple md-just-icon" @click="deleteFile">
			<i class="fa fa-trash-o"></i>
		</md-button>
	</div>
</template>

<script>
import CommonFileUpload from "@/components/templates/common/CommonFileUpload.vue";
import EnumSelect from "@/components/templates/select/EnumSelect.vue";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		EnumSelect,
		CommonFileUpload
	},
	props: {
		file: { type: Object, default: null },
		uploadFunction: { type: Function },
		defaultType: { type: Number, default: null },
		allowChangeType: { type: Boolean, default: true },
		required: { type: Boolean, default: false },
		error: { type: String, default: null },
		forInstallmentContract: { type: Boolean, default: false }
	},
	data() {
		return {
			uploadedFile: this.file,
			selectedType: this.file ? this.file.type : this.defaultType,
			enumDef: enumDef
		};
	},
	computed: {
		// Allows v-model approach and validation
		value() {
			return this.uploadedFile;
		},
		fileTypeCandidates() {
			let result = this.forInstallmentContract? this.enumDef.fileMappingType.additionalInstallmentContractDocumentTypes() : this.enumDef.fileMappingType.additionalReceivableDocumentTypes();
			return result;
		}
	},
	methods: {
		uploadDocumentWithSelectedType(params) {
			return this.uploadFunction(this.selectedType, params);
		},
		onFileChanged(newFile) {
			newFile.type = this.selectedType;
			this.setUploadedFile(newFile);

			this.$emit("upload", newFile);
		},
		deleteFile() {
			this.setUploadedFile(null);
			this.$emit("delete");
		},
		setUploadedFile(newFile) {
			this.uploadedFile = newFile;

			// Allows v-model approach and validation
			this.$emit("input", newFile);
		}
	}
};
</script>